<template>
  <div>
    <nba-news :Position="Profile" :news="news" v-if="sportId == 1" />
    <mlb-news :Position="Profile" :news="news" v-if="sportId == 2" />
    <nfl-news :Position="Profile" :news="news" v-if="sportId == 4" />
    <nhl-news :Position="Profile" :news="news" v-if="sportId == 3" />
  </div>
</template>

<script>
import NflNews from "./playerNews/NflNewsComponent.vue";
import MlbNews from "./playerNews/MlbNewsComponent.vue";
import NhlNews from "./playerNews/MlbNewsComponent.vue";
import NbaNews from "./playerNews/NbaNewsComponent.vue";
export default {
  name: "NewsTab",
  components: { MlbNews, NflNews, NhlNews, NbaNews },
  props: {
    news: {
      type: [Array, Object],
      required: true,
      default: () => [],
    },
    sportId: {
      type: [String, Number],
      default: "",
    },
    Profile: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style></style>
